const identityMatrix = () => new DOMMatrix([1, 0, 0, 1, 0, 0])

export {
  // eslint-disable-next-line import/prefer-default-export
  identityMatrix,
}
